
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    ElementRef,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';

import { ExpandModalDialog } from 'app/modules/well-integrity-management/component/expand-modal/expand-modal.component';
import module from 'app/modules/well-integrity-management/well-integrity-management.module';
import {
    OtherActivitiesResponse,
    RemedialProgressResponse,
    UnhealthyWellsResponse,
    WellMaintenanceResponse,
} from '../../model/well-integrity-management.type';
import { WellIntergrityManagementService } from '../../service/well-intergrity-management.service';
import { RoleUtils } from 'app/core/auth/roles.utils';
import { Router } from '@angular/router';
import { switchMap, of, catchError } from 'rxjs';



@Component({
    selector: 'app-overall-overview',
    templateUrl: './overall-overview.page.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: module,
    styleUrls: ['./overall-overview.page.scss'],
})
export class OverallOverviewPage implements OnInit {
    currentYear: number = new Date().getFullYear();
    seriesData: any = [];
    category: any = [];
    unhealthyWellsData: UnhealthyWellsResponse;
    wellMaintenanceData: WellMaintenanceResponse;
    remedialProgressData: RemedialProgressResponse;
    otherActivitiesData: OtherActivitiesResponse;
    wipRemarkData: any = null;

    displayedColumns = ['risk', 'ranking', 'active', 'idle'];

    constructor(
        private readonly elementRef: ElementRef,
        public dialog: MatDialog,
        private readonly service: WellIntergrityManagementService,
        private readonly cdr: ChangeDetectorRef,
        private readonly destroyRef: DestroyRef,
        private router: Router,
    ) { }

    ngOnInit(): void {
        // TODO: Remove this code when changes direct page
        if (RoleUtils.currentRoles.includes('Offshore Personnel')) {
            this.router.navigate(['/data-management/cdft'], {
                replaceUrl: true, // 🔴 do not keep previous URL in history
            });
        }
        //

        this.fetchUnhealthyWells();
        this.fetchWellMaintenance();
        this.fetchRemedialProgress();
        this.fetchOtherActivities();
        this.fetchRemarks();
    }

    fetchUnhealthyWells() {
        this.service
            .getUnhealthyWells()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response) => {
                this.unhealthyWellsData = response;
                this.cdr.markForCheck();
            });
    }

    fetchWellMaintenance() {
        this.service
            .getWellMaintenancePlanVsActual()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response) => {
                this.wellMaintenanceData = response;
                this.cdr.markForCheck();
            });
    }

    fetchRemedialProgress() {
        this.service
            .getRemedialProgress()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response) => {
                this.remedialProgressData = response;
                this.cdr.markForCheck();
            });
    }

    fetchOtherActivities() {
        this.service
            .getOtherActivities()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response) => {
                this.otherActivitiesData = response;
                this.cdr.markForCheck();
            });
    }


    openDialog(title: string, componentName: string, functionName: string) {
        return () => {
            var component = document.getElementById(componentName);

            const dialogRef = this.dialog.open(ExpandModalDialog, {
                data: {
                    title: title,
                    viewComponent: component,
                    functionName: functionName,
                }, // Pass your parameters here
            });

            dialogRef.afterClosed().subscribe((result) => {
                console.log(`Dialog result: ${result}`);
            });
        };
    }

    fetchRemarks(): void {
        this.service.getWipRemark().pipe(
            switchMap((res) => {
                const remarksId = res?.data?.data?.[0]?.id ?? null;

                if (!remarksId) {
                    return of(null);
                }

                return this.service.getWipRemarkbyId(remarksId);
            }),
            catchError((err) => {
                console.error('Error fetching remarks:', err);
                return of(null);
            })
        ).subscribe((response) => {
            this.wipRemarkData = response?.data ?? null;
            // this.wipRemarkData.attachments = response?.data?.attachments ?? [];

            console.log('Data received:', this.wipRemarkData);
            this.cdr.markForCheck();
        });
    }
}
